import { createSelector } from "@ngrx/store";
import { ConfigModel } from "../actions";
import { orderBy } from "lodash";

export const getState = (state) => state.appConfig;

export const getAppFeatures = createSelector(getState, (data: ConfigModel) => {
  return orderBy([], ["key"], ["asc"]);
});
